module.exports = __webpack_public_path__ + "img/boiler-E-light.41788844.png";